import {
  MAILBOX_DELIVERY_TIME, SEED_COSTS, SeedOrderLine, SeedType, SimState,
} from './types';
import { EventBus } from './events';

/**
 * Mailbox: place a seed order, wait MAILBOX_DELIVERY_TIME seconds, seeds
 * land in the player's inventory. Only one order can be in flight at a time.
 */
export const MailboxSystem = {
  isBusy(state: SimState): boolean {
    return state.mailbox.pending !== null;
  },

  /** Compute total cost of an order. */
  cost(order: SeedOrderLine[]): number {
    return order.reduce((s, l) => s + SEED_COSTS[l.seed] * l.qty, 0);
  },

  placeOrder(state: SimState, order: SeedOrderLine[], bus: EventBus): boolean {
    if (this.isBusy(state)) {
      bus.emit({ type: 'blocked', reason: 'An order is already on its way.' });
      return false;
    }
    const cleaned = order.filter(l => l.qty > 0);
    if (cleaned.length === 0) {
      bus.emit({ type: 'blocked', reason: 'Pick some seeds to order.' });
      return false;
    }
    const total = this.cost(cleaned);
    if (state.res.money < total) {
      bus.emit({ type: 'blocked', reason: `Need ${total} coins for that order.` });
      return false;
    }
    state.res.money -= total;
    state.mailbox.pending = cleaned;
    state.mailbox.eta = MAILBOX_DELIVERY_TIME;
    state.mailbox.paid = total;
    bus.emit({ type: 'orderPlaced', cost: total });
    bus.emit({ type: 'hint', text: `Order placed (${total} coins) — arriving in ~${MAILBOX_DELIVERY_TIME}s.` });
    return true;
  },

  tick(state: SimState, dt: number, bus: EventBus) {
    const m = state.mailbox;
    if (!m.pending) return;
    m.eta -= dt;
    if (m.eta <= 0) {
      // Deliver — add seeds to inventory
      for (const line of m.pending) {
        state.res.seeds[line.seed] = (state.res.seeds[line.seed] ?? 0) + line.qty;
      }
      bus.emit({ type: 'orderDelivered', lines: m.pending });
      bus.emit({ type: 'hint', text: 'Seed delivery arrived!' });
      m.pending = null;
      m.eta = 0;
      m.paid = 0;
    }
  },
};

